(() => {
  function init(root) {
    if (root.dataset.guideReady) return;
    root.dataset.guideReady = 'true';
    const dialog = root.querySelector('dialog');
    const content = dialog.querySelector('[data-guide-content]');
    let trigger, scrollY = 0, oldOverflow = '';
    function close() { if (dialog.open) dialog.close(); }
    dialog.addEventListener('close', () => {
      content.querySelectorAll('video').forEach(video => { video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach(source => source.removeAttribute('src')); video.load(); });
      content.replaceChildren();
      document.body.style.overflow = oldOverflow;
      window.scrollTo(0, scrollY);
      if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
    });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-guide-open]');
      if (!button || !root.contains(button)) return;
      const template = Array.from(root.querySelectorAll('template')).find(item => item.dataset.guideTemplate === button.dataset.guideOpen);
      if (!template) return;
      trigger = button;
      content.replaceChildren(template.content.cloneNode(true));
      const title = content.querySelector('[data-guide-title]');
      title.id = `guide-modal-title-${button.dataset.guideOpen}`;
      dialog.setAttribute('aria-labelledby', title.id);
      scrollY = window.scrollY;
      oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      dialog.querySelector('[data-guide-close]').focus();
      const video = content.querySelector('video');
      if (video) { video.setAttribute('playsinline', ''); video.preload = 'metadata'; video.load(); }
    });
    dialog.querySelector('[data-guide-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    root.addEventListener('shopify:block:select', event => {
      const button = event.target.querySelector('[data-guide-open]');
      if (button) button.scrollIntoView({ block: 'center' });
    });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) close(); }, { once: true });
  }
  document.querySelectorAll('[data-video-guide]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-video-guide]').forEach(init));
})();
